'use strict';

function dialogParent() {
    if (typeof angular !== 'undefined' && angular.element) {
        return angular.element('body');
    }

    return null;
}

function typedCredentialsDialogConfig(integrationTemplate, onSuccess) {
    return {
        locals: {
            integrationTemplate: integrationTemplate,
            onSuccess: onSuccess,
        },
        controller: 'TypedCredentialsDialogCtrl',
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: '/js/integrations/typed-credentials/typed-credentials-dialog.html',
        parent: dialogParent(),
        clickOutsideToClose: false,
        escapeToClose: true,
    };
}

function integrationTemplateLookupFilter(provider) {
    return {
        where: {
            provider: provider,
        },
        fields: ['id', 'name', 'provider', 'strategy', 'credentialFields'],
    };
}

function applyIntegrationToEditApp(context, integration) {
    if (context.ListModifier && context.integrations) {
        context.ListModifier.add(context.integrations, integration);
    }

    context.$timeout(function () {
        context.app.integrationId = integration.id;

        if (context.form && context.form.$setDirty) {
            context.form.$setDirty();
        }
    });
}

function captureConnectError(context, error) {
    if (typeof console !== 'undefined' && console.error) {
        console.error(error);
    }

    if (context.Raven && context.Raven.captureException) {
        context.Raven.captureException(error);
    }
}

function connectEditAppIntegration(context) {
    var template = context.integrationTemplate;

    if (template && template.strategy === 'typed') {
        return context.$mdDialog.show(typedCredentialsDialogConfig(template, function (integration) {
            applyIntegrationToEditApp(context, integration);
        }));
    }

    var UI_URI = context.envService.read('UI_URI');
    var config = {
        url: UI_URI + '/social/' + template.provider + '/' + template.id,
        redirectUri: UI_URI + '/social/' + template.provider + '/callback',
        popupOptions: {
            width: 900,
            height: 600,
        },
    };

    return context.Popup.open(config)
        .then(function (result) {
            return context.Integration.findById({
                id: result.id,
                filter: context.Includes.integrations,
            }).$promise.then(function (response) {
                applyIntegrationToEditApp(context, response);
                return response;
            });
        })
        .catch(function (error) {
            captureConnectError(context, error);
        });
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        applyIntegrationToEditApp: applyIntegrationToEditApp,
        connectEditAppIntegration: connectEditAppIntegration,
        integrationTemplateLookupFilter: integrationTemplateLookupFilter,
        typedCredentialsDialogConfig: typedCredentialsDialogConfig,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('editAppConnect', {
        applyIntegrationToEditApp: applyIntegrationToEditApp,
        connectEditAppIntegration: connectEditAppIntegration,
        integrationTemplateLookupFilter: integrationTemplateLookupFilter,
        typedCredentialsDialogConfig: typedCredentialsDialogConfig,
    });
}
